module.exports = __webpack_public_path__ + "static/img/badge.ded688d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badge.png
// module id = A2cm
// module chunks = 35